import React from 'react';
import PropTypes from 'prop-types';

import ProductParameters from './ProductParameters';

const Title = ({ side, parameters }) => {
  let text = '';
  if (side === 'top') {
    text = 'Top Stencil'
  } else if (side === 'bottom') {
    text = 'Bottom Stencil'
  } else if (side === 'combined') {
    text = 'Combined Top & Bottom Stencil'
  } else if (side === 'both') {
    if (parameters.stencil_side.includes('Top'))
      text = 'Top Stencil'
    else
      text = 'Bottom Stencil'
  }
  return(
    <h5 className="title">{text}</h5>
  )
}
const StencilItem = ({ productItem, reference, onChangeParameter, stencilsSide, validator }) => {
  const { product, parameters, quantity } = productItem;

  return (
    <div className="stencil-item">
      <Title side={stencilsSide} parameters={parameters} />
      <ProductParameters
        product={product}
        parameters={parameters}
        onChangeParameter={onChangeParameter}
        reference={reference}
        validator={validator} />
    </div>
  )
};

StencilItem.prototype = {
  reference: PropTypes.number.isRequired,
  productItem: PropTypes.shape({
    product: PropTypes.object.isRequired,
    parameters: PropTypes.object.isRequired,
    quantity: PropTypes.string.isRequired,
  }),
  onChangeParameter: PropTypes.func.isRequired,
}

export default StencilItem;
